let counter = 0;

export const createUniqueRuntimeNumber = () => (counter += 1);
